import React, { useRef } from 'react';
import { X } from 'lucide-react';
import styles from '../UrlInput/UrlInput.module.css'; // Utilizziamo gli stessi stili di UrlInput

export interface ExtendedTextInputProps {
  id: string; // UrlInput richiede id
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement> | string) => void; // Firma di onChange come UrlInput
  label?: string; // Label opzionale, UrlInput la ha
  placeholder?: string;
  disabled?: boolean;
  className?: string; // Classe per il contenitore principale
  inputClassName?: string; // Classe specifica per l'elemento input
  showClearButton?: boolean;
  name?: string; // Aggiungiamo name per coerenza con TextInput originale e attributi HTML
  // Altre props HTML standard per input verranno passate con ...rest
}

export const ExtendedTextInput: React.FC<ExtendedTextInputProps> = ({
  id,
  value,
  onChange,
  label, // Se non fornita, la label non verrà renderizzata o sarà vuota
  placeholder,
  disabled = false,
  className = '', // Classe per il contenitore .urlInputContainer
  inputClassName = '', // Classe per l'elemento input .inputField
  showClearButton = true,
  name, // Aggiunto name
  ...rest // Per passare altre props HTML all'input
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  // Gestore onChange per ExtendedTextInput, deve emettere ChangeEvent o stringa
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // La prop onChange può accettare un ChangeEvent o una stringa.
    // Se la firma originale di TextInput era (event: React.ChangeEvent<HTMLInputElement> | { target: { value: string; name?: string } }) => void;
    // dobbiamo decidere come adattarla. Per ora, replichiamo il comportamento di UrlInput.
    onChange(event);
  };

  const handleClear = () => {
    // UrlInput passa una stringa vuota
    onChange('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const isClearButtonVisible = showClearButton && value && !disabled;

  return (
    <div className={`${styles.urlInputContainer} ${className}`}>
      {label && ( // Renderizza la label solo se fornita
        <label htmlFor={id} className="input-label">
          {label}
        </label>
      )}
      <div className={styles.inputWrapper}>
        <input
          ref={inputRef}
          type="text" // Tipo TEXT invece di URL
          id={id}
          name={name} // Aggiunto name all'input
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${styles.inputField} ${isClearButtonVisible ? styles.inputWithClear : ''} ${inputClassName}`}
          {...rest} // Passa le altre props all'input
        />
        {isClearButtonVisible && (
          <button
            type="button"
            onClick={handleClear}
            className={styles.clearButton}
            aria-label="Clear input" // Manteniamo aria-label per accessibilità
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};